/* eslint-disable */
// Note NOOM MOD below.
import { LibCategories, waitForConsent } from "src/utils/consent";

declare const window: Window & {
  jumbleberry: any;
  _RNGSeed: any;
};

const tagName = "script";
const domain = "https://www.hundred-coin-far.com/";
const i = "3.2.1";

var jumbleberry: any = function (...args) {
  // NOOM MOD: Wrapped entry point in consent check
  waitForConsent([LibCategories.targetingCookies]).then(() => {
    jumbleberry.v == i && jumbleberry.e
      ? jumbleberry.e.apply(jumbleberry, args)
      : jumbleberry.q.push(args);
  });
  // END NOOM
};
const a = encodeURIComponent;
const t = decodeURIComponent;
const d = window.location;
(jumbleberry.push = jumbleberry).l = !1;
jumbleberry.q = [];
jumbleberry.v = i;
jumbleberry.duid = function (n) {
  return (n =
    n &&
    document.cookie.match(RegExp(`${t("%5Cb") + n.substr(0, 21)}id=([^;]+)`)))
    ? t(n[1].split(".")[0])
    : "";
};
jumbleberry.g = function (n, i) {
  return (
    !!(i = RegExp(`^[^#]*[?&]${n}=([^&#]+)`).exec(i || d.href)) &&
    t(i[1].replace(/\+/g, " "))
  );
};
jumbleberry.s = function (n) {
  for (
    let i = Math.round(new Date().getTime() / 1e3),
      t = d.hostname.split("."),
      r = t.length - 1;
    r-- > 0 &&
    /^(([a-z0-9]{4}-?){8}|[0-9]+)$/i.test(n) &&
    n != jumbleberry.duid(jumbleberry.p);

  )
    document.cookie = `${jumbleberry.p.substr(0, 21)}id=${a(
      n
    )}.${i}.0.${i}.; path=/; max-age=63072000; domain=.${t
      .slice(r, t.length)
      .join(".")}`;
};
jumbleberry.i = function (n, i, t) {
  if (n == "init")
    return [
      (jumbleberry.u = jumbleberry.duid((jumbleberry.p = i))),
      jumbleberry.s((jumbleberry.h = t || jumbleberry.u)),
    ];
  (t = t || {}),
    ((n = document.createElement("iframe")).src = `${
      jumbleberry.d + jumbleberry.p
    }?hid=${a(jumbleberry.h)}&uid=${a(jumbleberry.u)}&event=${a(
      i || ""
    )}&transid=${a(t.transaction_id || "")}&oi=${a(
      t.order_index || ""
    )}&ctx=${a(JSON.stringify(t))}`),
    (n.height = n.width = 0),
    (n.style = "display:none;visibility:hidden"),
    (n.sandbox = "allow-forms allow-same-origin allow-scripts"),
    (n.referrerPolicy = "unsafe-url"),
    (document.body || document.head).appendChild(n);
};
jumbleberry.m = jumbleberry.e = function () {
  let n;
  let i;
  if (!window._RNGSeed && jumbleberry.i.apply(jumbleberry, arguments)) {
    n = document.createElement(tagName);
    i = document.getElementsByTagName(tagName)[0];
    n.src = `${jumbleberry.d + jumbleberry.p}?hid=${a(jumbleberry.h)}&uid=${a(
      jumbleberry.u
    )}&v=${jumbleberry.v}`;
    n.async = !!jumbleberry.h;
    jumbleberry.e = !1;
    jumbleberry.q.unshift(arguments);
    window.addEventListener(
      "beforeunload",
      (n.onerror = function () {
        jumbleberry.e = jumbleberry.i;
        for (let n = 0; n < jumbleberry.q.length; ++n)
          jumbleberry.apply(jumbleberry, jumbleberry.q[n]);
        jumbleberry.q = [];
      })
    );
    i.parentNode.insertBefore(n, i);
  }
};
window.jumbleberry = jumbleberry;
window.jumbleberry.d = domain;

export default jumbleberry;
